

































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import {
  createCourse,
  getCourse,
  renameCourse,
  getCourseDetail,
  upCourseDetail,
  upIndependent, updateEnrollSetting
} from '@/apis/courseList/courseList';
import { Dialog, Toast } from 'vant';
import { NavigationGuardNext, Route } from 'vue-router';
import store from '@/store';
import i18n from '@/lang/index';

interface ActionSheetItem {
  name: string
}

@Component
export default class NewCourse extends Vue {
  private courseId = '';
  private courseName = '';
  private className = '';
  private venue = ''; // 授课地点
  private semester = i18n.t('CommonComponents.请选择') as string;
  private courseTerms = i18n.t('CommonComponents.请选择') as string;
  private activeNames = '';
  private isNeedNatureClass = false;
  private isNeedGrade = false;
  private isNeedDate = false;
  private isShowToBackend: 1 | 0 = 1;
  private isShowActionSheet = false;
  private actionsList: Array<ActionSheetItem> = [];
  private actionType: 'semester' | 'term' = 'semester';
  private showTeachingMod = false;
  private teachType = 0; // 授课模式
  private teachTypeName = '';
  private studyTime = ''; // 学时
  private teachingMod = [ // 授课模式
    {
      id: 1,
      name: i18n.t('Common.线上') as string
    },
    {
      id: 2,
      name: i18n.t('Common.线下') as string
    },
    {
      id: 3,
      name: i18n.t('Common.混合') as string
    }
  ];

  private sumbitIng=false

  beforeRouteEnter(to: Route, from: Route, next: NavigationGuardNext<Vue>) {
    if(from.path !== '/seniorSetting') {
      store.state.courseEnrollForm = {
        enrollstate: '0',
        auditstate: '0',
        joinlabelid: '',
        formLists: [
          { title: i18n.t('Home.姓名') as string, selected: '0' },
          { title: i18n.t('Home.手机') as string, selected: '0' },
          { title: i18n.t('Home.学号') as string, selected: '0' },
          { title: i18n.t('Home.工号') as string, selected: '0' },
          { title: i18n.t('Home.学校') as string, selected: '0' },
          { title: i18n.t('Home.公司') as string, selected: '0' },
        ]
      }
    }
    next();
  }

  get courseEnrollForm() {
    return this.$store.state.courseEnrollForm;
  }

  handleActionSheetClose() {

  }

  @Watch('teachType')
  onTeachTypeChange(newVal: number) {
    const item = this.teachingMod.find(item => item.id === newVal);
    if (item) {
      this.teachTypeName = item.name;
    } else {
      this.teachTypeName = '';
    }
    // this.teachTypeName = this.teachingMod.find(item => item.id === newVal).name || ''
  }

  // 去高级设置
  goSeniorSetting() {
    sessionStorage.createCourse = JSON.stringify({
      courseId: this.courseId,
      courseName: this.courseName,
      className: this.className,
      venue: this.venue,
      isShowToBackend: this.isShowToBackend,
      semester: this.semester,
      courseTerms: this.courseTerms,
      teachType: this.teachType,
      studyTime: this.studyTime
    });
    this.$router.push('/seniorSetting');
  }

  showActionList(type: 'semester' | 'term') {
    this.actionType = type;
    if (this.actionType === 'semester') {
      const thisYear = new Date().getFullYear();
      this.actionsList = [{ name: `${thisYear - 2}-${thisYear - 1}` }, { name: `${thisYear - 1}-${thisYear}` }, { name: `${thisYear}-${thisYear + 1}` }];
    }
    if (this.actionType === 'term') {
      this.actionsList = [{ name: i18n.t('CourseHome.全年') as string }, { name: i18n.t('Home.第一学期') as string }, { name: i18n.t('Home.第二学期') as string }];
    }

    this.isShowActionSheet = true;
  }

  handleActionSheetCandel() {
    switch (this.actionType) {
      case 'semester':
        this.semester = i18n.t('CommonComponents.请选择') as string;
        break;
      case 'term':
        this.courseTerms = i18n.t('CommonComponents.请选择') as string;
        break;
    }
  }

  onSelect(item: ActionSheetItem) {
    switch (this.actionType) {
      case 'semester':
        this.semester = item.name;
        break;
      case 'term':
        this.courseTerms = item.name;
        break;
    }
    this.isShowActionSheet = false;
  }

  onSelectTeachingMod(item: { name: string, id: number }) {
    this.teachType = item.id;
    // this.teachTypeName = item.name
    this.showTeachingMod = false;
  }

  onSubmit() {
    if (!this.courseName || this.courseTerms === i18n.t('CommonComponents.请选择') || this.semester === i18n.t('CommonComponents.请选择')) {
      let tipsMessage = `${!this.courseName ? i18n.t('Home.请填写课程名称') : ''}`;
      if(tipsMessage == ''){
        tipsMessage = `${this.semester === i18n.t('CommonComponents.请选择') ? i18n.t('Home.请选择学年') : ''}`;
      }
      if(tipsMessage == ''){
        tipsMessage = `${this.courseTerms === i18n.t('CommonComponents.请选择') ? i18n.t('Home.请选择学期') : ''}`;
      }
      Dialog.alert({
        title: i18n.t('CommonComponents.标题') as string,
        message: tipsMessage
      }).then(() => {
        // on close
      });
    } else if (this.courseId) {
      this.sumbitIng = true;
      upCourseDetail({
        courseid: this.courseId,
        coursename: this.courseName,
        classname: this.className,
        venue: this.venue,
        canview: this.isShowToBackend ? 1 : 0,
        semester: this.semester,
        term: this.courseTerms === i18n.t('Home.第一学期') ? '1' : this.courseTerms === i18n.t('Home.第二学期') ? '2' : '0',
        teachtype: this.teachType,
        studytime: Number(this.studyTime) + ''
      }).then(async (res) => {
        this.sumbitIng = false;
        await updateEnrollSetting({
          courseid: this.courseId,
          ...this.courseEnrollForm,
        })
        Dialog.alert({
          title: i18n.t('Home.编辑成功') as string,
          message: `${i18n.t('Common.编辑')}${this.courseName}${i18n.t('Home.成功')}`
        }).then(() => {
          this.$router.back();
        });
      }).catch(e => {
        this.sumbitIng = false;
        Dialog.alert({ message: e.message });
      });
    } else {
      this.sumbitIng = true;
      createCourse({
        coursename: this.courseName,
        classname: this.className,
        venue: this.venue,
        semester: this.semester,
        term: this.courseTerms === i18n.t('Home.第一学期') ? '1' : this.courseTerms === i18n.t('Home.第二学期') ? '2' : '0',
        teachtype: this.teachType,
        studytime: this.studyTime,
        // describes: this.$store.state.courseStore.seniorSettingParams.describes,
        canview: this.isShowToBackend,
      }).then(async (res: any) => {
        this.sumbitIng = false;
        this.$store.state.newCourseId = res.id;
        await updateEnrollSetting({
          courseid: res.id,
          ...this.courseEnrollForm,
        })
        Toast.success(`${i18n.t('Home.创建')}${this.courseName}${i18n.t('Home.成功')}`);
        this.$router.push({
          path: '/chooseCourseModule',
          query: {
            // id: res.id
          }
        })
        sessionStorage.removeItem('createCourse');
      }).catch(e => {
        this.sumbitIng = false;
        Dialog.alert({ message: e.message });
      });
    }
  }

  created() {
    if (this.$route.query.id) {
      this.courseId = this.$route.query.id as string;
      this.$setNavInfo({ title: i18n.t('Home.Handle.编辑课程') as string });
      getCourseDetail({ courseid: this.courseId }).then((res: any) => {
        this.courseName = res.coursename;
        this.className = res.classname || '';
        this.venue = res.venue || '';
        this.isNeedNatureClass = Boolean(res.setting?.classno);
        this.isNeedDate = Boolean(res.setting?.enrolltime);
        this.isNeedGrade = Boolean(res.setting?.grade);
        this.courseTerms = res.term === '1' ? i18n.t('Home.第一学期') as string : res.term === '2' ? i18n.t('Home.第二学期') as string : i18n.t('CourseHome.全年') as string;
        this.semester = res.semester || '';
        this.studyTime = res.studytime !== '-1' ? res.studytime : '';
        this.teachType = Number(res.teachtype) || 0;
        this.isShowToBackend = res.canview;
        // console.log(e)
        sessionStorage.setItem('courseInfo', JSON.stringify(res));
        this.$store.state.courseEnrollForm = res.enrollSetting;
      });
    }
    this.$nextTick(() => {
      if (sessionStorage.getItem('inCreate') || this.courseId) {
        this.activeNames = '1';
      }
      // 判断是不是从高级设置中返回的
      if(sessionStorage.createCourse && sessionStorage.inCreate) {
        this.creating()
      }
    });
  }

  validStudyTime(val: string) {
    if (val === '-' || val === '.') return false;
    if (val === '' || val === '0' || val === '0.') return true;
    if (val.indexOf('.') === 1 && val.length > 3) {
      this.studyTime = Number(val).toFixed(1) + '';
    }
    return Number(val) > 0;
  }

  // 从高级设置中返回
  creating() {
    const obj: any = JSON.parse(sessionStorage.createCourse);
    const _this: any = this
    for (let key in obj) {
      if(obj.hasOwnProperty(key) && _this.hasOwnProperty(key)) {
        _this[key] = obj[key]
      }
    }
  }

  studyTimeBlur() {
    // if (this.studyTime === '') {
    //   this.studyTime = '-1';
    // }
  }

  destroyed() {
    sessionStorage.removeItem('inCreate');
  }
  
}
